module.exports = __webpack_public_path__ + "img/menus_05.86cd155a.png";